import React, { useState, useEffect } from 'react';
// import logo from '../../assets/images/404img.gif'
import loginLogo from '../../src/assets/images/login-logo.png';

const NoInternetConnection = (props) => {
    const [isOnline, setOnline] = useState(true);
    window.addEventListener('online', () => { setOnline(true) });
    window.addEventListener('offline', () => { setOnline(false) });

    if (isOnline) {
        return (
            props.children
        )
    } else {
        return (
            <div className="pt-16 bg-[#fff] h-screen justify-center" >
                <div className="flex mt-5 flex-wrap flex-row align-center justify-center content-center auto-rows-max">
                    <img className="relative xl:h-[5.469vw] xl:w-[5.469vw]" src={loginLogo}
                                    width={"103"} height={"105"} alt="GUSD App" />
                </div>
                <h3 className="font-bold text-[30px] text-[#525252] text-center">No Internet Connection.</h3>
            </div>
        )
    }
}

export default NoInternetConnection;